// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum POST_COLLAB_DOC_VARIANT {
    full = 'full',
    preview = 'preview',
}
